import axiosInstance from "../../utility/axios";
import {
  setNotifications,
  setNotification,
  // createNotification,
  deleteNotification as deleteNotificationById,
  setLoading,
  setError,
  clearError,
  stopDeleting,
  startDeleting,
} from "../../store/slices/notification";
import { AppDispatch } from "../../store/store";
import { isAxiosError } from "axios";
import { ICreateNotification } from "../../store/types/notification";
import { toast } from "sonner";

export const getNotifications = async (dispatch: AppDispatch) => {
  dispatch(setLoading());
  dispatch(clearError());
  try {
    const response = await axiosInstance.get("/v1/get-notifications");
    const { message } = response?.data;
    // The response has the data nested under "message"
    dispatch(setNotifications(message));
    return { success: true, data: message };
  } catch (err) {
    if (isAxiosError(err)) {
      const errorMessage =
        err.response?.data?.message || "Failed to fetch notifications";
      dispatch(setError(errorMessage));
      toast.error(errorMessage);
      return { success: false, error: errorMessage };
    }
  } finally {
    dispatch(setLoading());
  }
};

export const getNotification = async (dispatch: AppDispatch, id: string) => {
  dispatch(setLoading());
  dispatch(clearError());
  try {
    const response = await axiosInstance.get(`/v1/get-notifications/${id}`);
    const { data } = response?.data;

    dispatch(setNotification(data));
    return { success: true, data };
  } catch (err) {
    if (isAxiosError(err)) {
      const errorMessage =
        err.response?.data?.message || "Failed to fetch notification";
      dispatch(setError(errorMessage));
      toast.error(errorMessage);
      return { success: false, error: errorMessage };
    }
  } finally {
    dispatch(setLoading());
  }
};

export const createNotification = async (
  formData: ICreateNotification,
  dispatch: AppDispatch
) => {
  dispatch(setLoading());
  dispatch(clearError());
  try {
    const response = await axiosInstance.post(
      "/v1/create-notifications",
      formData
    );
    const { message } = response?.data;

    toast.success(message);
    // Refresh notifications list to include the new one
    await getNotifications(dispatch);
    return { success: true };
  } catch (err) {
    if (isAxiosError(err)) {
      const errorMessage =
        err.response?.data?.message || "Failed to create notification";
      dispatch(setError(errorMessage));
      toast.error(errorMessage);
      return { success: false, error: errorMessage };
    }
  } finally {
    dispatch(setLoading());
  }
};

export const deleteNotification = async (id: number, dispatch: AppDispatch) => {
  dispatch(clearError());
  dispatch(startDeleting(id));
  try {
    const response = await axiosInstance.delete(
      `/v1/delete-notifications/${id}`
    );
    const { message } = response?.data;

    toast.success(message);
    dispatch(deleteNotificationById(id));
    return { success: true };
  } catch (err) {
    dispatch(stopDeleting(id));
    if (isAxiosError(err)) {
      const errorMessage =
        err.response?.data?.message || "Failed to delete notification";
      dispatch(setError(errorMessage));
      toast.error(errorMessage);
      return { success: false, error: errorMessage };
    }
  }
};
